<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext" v-if="!isHide">
      <div class="container">
        <div
          class="area_wrap"
          :class="{ emptyList: getCertificateList.length <= 0 }"
        >
          <div class="paper_wrap" v-if="getCertificateList.length > 0">
            <div class="pw_title">
              <p>서류명</p>
              <p>장당금액(원)</p>
            </div>
            <div class="pw_list">
              <div class="label_wrap full">
                <div class="lw_item_wrap">
                  <div
                    class="lw_item list"
                    v-for="c in getCertificateList"
                    :key="c.id"
                    :class="{ detailNoneList: c.detail === null }"
                  >
                    <input
                      type="checkbox"
                      :id="c.id"
                      :value="c.id"
                      v-model="form.id.value"
                      :name="c.name"
                      :detail="c.detail"
                      :price="c.price"
                      @click.once="checkValue(c.name)"
                      ref="input"
                      class="certificateCodeList"
                    />
                    <label :for="c.id" class="type">
                      <div class="lw_textWrap">
                        <div class="lw_left">
                          <p
                            class="nameVal"
                            :value="c.name"
                            :class="{ active: isActive }"
                          >
                            {{ c.name }}
                          </p>
                          <p class="detailVal" :value="c.detail">
                            {{ c.detail }}
                          </p>
                        </div>
                        <div class="lw_right">
                          <p class="priceVal" :value="c.price">
                            {{ c.price | plusComma }}원
                          </p>
                        </div>
                      </div>
                      <span class="cw_checkImg"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="description full">
              <p>*1~5매(장당 1,000), 6매 이상(장당 100원 추가)</p>
              <p>
                *제증명 발급 신청이 '발급완료' 상태인 경우에는 취소가
                불가합니다.
              </p>
              <p>
                *증명서 발급 비용은 증명서를 수령하실 때 일괄적으로 하시면
                됩니다.
              </p>
            </div>
          </div>
          <div v-else>
            <div class="center_text surgery">
              <div class="imgWrap">
                <img src="@/assets/images/error.svg" />
              </div>
              <div class="ct_content">
                <p>신청할 수 있는 증명서가 없습니다.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="btnWrap visible"
        :class="{ half: halfFlag }"
        v-if="getCertificateList.length > 0"
      >
        <router-link to="/">
          <button type="button" class="callTerms cancel">취소</button>
        </router-link>
        <button type="button" class="callTerms" @click="nextDone()">
          확인
        </button>
      </div>
      <!--test-->
      <!--      <div class="btnWrap visible" v-else>-->
      <!--        <router-link to="/">-->
      <!--          <button type="button" class="callTerms">목록</button>-->
      <!--        </router-link>-->
      <!--      </div>-->
    </div>
    <div class="appContext err-view" v-else>
      <div class="container">
        <div class="area_wrap">
          <div class="full blank">
            <div class="center_text surgery">
              <div class="imgWrap">
                <img src="@/assets/images/error.svg" />
              </div>
              <div class="ct_content">
                <p>준비중입니다.</p>
                <p>현재 모든 서류는 직접 방문 수령 가능합니다. </p>
                <p>1522-8775 미리 신청 후 내원 부탁드립니다.  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible" @click="goMain()">
        <button type="button" class="callTerms">메인페이지 이동</button>
      </div>
    </div>
    <add-popup v-if="checkPopup" :popupSet="popupSet" />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
import AddPopup from "@/components/AddPopup";
import errorParser from "@/utils/error-parser";
import EventBus from "@/utils/bus";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      popupSet: {
        title: "",
        modalImg: "alert_cn.svg",
        content: "",
        confirmBtnText: "확인",
        count: "single",
        closeType: "close",
      },
      transDate: {
        headerName: "제증명 발급 신청",
        prevUrl: "/",
      },
      form: {
        requestData: [
          {
            id: "",
            name: "",
            detail: "",
            price: "",
          },
        ],
        id: {
          value: [],
        },
        name: {
          value: [],
        },
        detail: {
          value: [],
        },
        price: {
          value: [],
        },
        slideBlock: {
          id: "",
          name: "",
          detail: "",
          price: "",
        },
      },
      isHide: false,
      halfFlag: true,
      labelCheck: false,
      isActive: false,
      setCount: false,
    };
  },
  computed: {
    ...mapGetters("certificate", ["getCertificateList"]),
    ...mapState(["checkPopup"]),
  },
  methods: {
    ...mapMutations(["SET_POPUP"]),
    ...mapMutations("certificate", ["SET_SLIDE"]),
    ...mapMutations("referrer", ["SET_REFERRER"]),
    ...mapActions("certificate", ["CERTIFICATE_LIST"]),
    goMain() {
      location.href = "/";
    },
    checkValue(name) {
      const checkCount = document.getElementsByClassName("certificateCodeList");
      console.log("name: ", checkCount.checked);
      for (let i = 0; i < checkCount.length; i++) {
        if (checkCount[i].checked === true) {
          const nameVal = checkCount[i].getAttribute("name");
          const detailVal = checkCount[i].getAttribute("detail");
          const priceVal = checkCount[i].getAttribute("price");

          this.form.name.value.push(nameVal);
          this.form.detail.value.push(detailVal);
          this.form.price.value.push(priceVal);

          this.form.name.value.filter(
            (nameVal, index) => this.form.name.value.indexOf(nameVal) === index
          );

          if (name === "일반진단서") {
            this.popupSet.content =
              "일반진단서는 조직검사 결과가 나오는 <br/>" +
              "수술(퇴원)1주일 후부터 신청이 가능합니다. " +
              "1주일 이전 신청 시 발급 소요기간이 <br/>" +
              "더 길어질 수 있습니다.";
            this.popupSet.topImg = true;
            this.SET_POPUP(true);
          } else {
            this.SET_POPUP(false);
          }
        } else if (checkCount[i].checked === false) {
        }
      }
      // console.log(this.form.id.value.find(x => x === 1))
      // if (this.form.id.value.find(x => x === 1)) {
      //   this.popupSet.content = '일반진단서는 조직검사 결과가 나오는 <br/>' +
      //     '수술(퇴원)1주일 후부터 신청이 가능합니다. ' +
      //     '1주일 이전 신청 시 발급 소요기간이 <br/>' +
      //     '더 길어질 수 있습니다.'
      //   this.popupSet.topImg = true
      //   this.SET_POPUP(true)
      //   this.labelCheck = false
      // } else {
      //   this.SET_POPUP(false)
      // }
    },
    async fetchData() {
      try {
        this.CERTIFICATE_LIST();
      } catch (error) {
        console.log('error :', error);
        console.log("제증명 발급 신청 리스트 API에서 에러발생");
        if (error.status !== 401) {
          this.SET_POPUP(true);
          this.popupSet.content = errorParser.parse(error);
        } else {
          await this.$router.push("/login");
        }
      }
    },
    nextDone() {
      if (this.form.id.value.length <= 0) {
        this.popupSet.content = "신청할 서류를 선택해주세요.";
        this.popupSet.topImg = false;
        this.SET_POPUP(true);
        return false;
      }

      const checkCount = document.getElementsByClassName("certificateCodeList");
      for (let i = 0; i < checkCount.length; i++) {
        const slide =
          checkCount[i].nextElementSibling.childNodes[0].childNodes[0]
            .childNodes[0].innerText;
        console.log("slide: ", slide);
        /* 슬라이드 블록 선택했을때 따로 저장 */
        if (slide.indexOf("슬라이드") >= 0) {
          const idVal = checkCount[i].getAttribute("id");
          const nameVal = checkCount[i].getAttribute("name");
          const detailVal = checkCount[i].getAttribute("detail");
          const priceVal = checkCount[i].getAttribute("price");

          const list = {
            id: idVal,
            name: nameVal,
            detail: detailVal,
            price: priceVal,
          };
          this.SET_SLIDE(list);
        }
      }
      sessionStorage.setItem("certificateCodeList", this.form.id.value);
      this.SET_REFERRER(window.location.href);
      this.$router.push("./certificateRequest");
    },
    callPrev() {
      if (this.setCount) {
        this.$router.push("/");
      } else {
        history.go(1);
      }
      this.setCount = true;
      // 클로즈 함수 구현
    },
  },
  filters: {
    plusComma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  created() {
    if (history.pushState !== undefined) {
      history.pushState({}, "", location.href);
      window.onpopstate = () => {
        this.callPrev();
      };
    }
    this.fetchData();
  },
  mounted() {
    this.isHide = true;
    EventBus.$emit("pageAccess", true);
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup,
  },
  beforeDestroy() {
    this.SET_POPUP(false);
    this.setCount = false;
    EventBus.$off("pageAccess");
  },
};
</script>

<style lang="scss" scoped>
</style>
